import { normalizeAndHashPhoneNumber, toSHA256String } from './convertToSHA256';

export const ADD_TO_CART_EVENT = "add_to_cart";
export const REMOVE_FROM_CART_EVENT = "remove_from_cart";
export const DELETE_ITEM_FROM_CART_EVENT = "delete_item_from_cart";
export const PURCHASE_EVENT = "purchase";
export const VIEW_ITEM_EVENT = "view_item";
export const VIEW_CART_EVENT = "view_cart";
export const OWA_HASH_CHANGE_EVENT = "owa_hash_change_event";
export const LOGIN = "login";
export const SEARCH = "search";
export const SIGN_UP = "sign_up";
export const VIEW_PROMOTION = 'view_promotion';
export const CHECKOUT = 'begin_checkout'

/** @typedef {import('$lib/types').MagentoCart} MagentoCart */
/** @typedef {import('$lib/types').MagentoCartTotals} MagentoCartTotals */
/** @typedef {import('$lib/types').MagentoCartItem} MagentoCartItem */
/** @typedef {import('$lib/types').MagentoCustomerOrderGQL} MagentoCustomerOrderGQL */
/** @typedef {import('$lib/types').PublicProduct} PublicProduct */

/**
 * @param {string} eventName
 * @param {any} params
 */
export const dispatchCustomEvent = async (eventName, ...params) => {
  switch (eventName) {
    case ADD_TO_CART_EVENT:
      {
        /** @type {[MagentoCart, string, number]} */
        const [cart, submittedSku, submittedQty] = params;
        /** @type {MagentoCartItem | undefined} */
        const item = cart.items
          .filter((item) => item.sku === submittedSku)
          .pop();
        if (item === undefined) {
          return;
        }
        /** @type {MagentoCartItem} */
        item;
        const detail = {
          currency: "GBP",
          value: Number((item.price * submittedQty).toFixed(2)),
          items: [
            {
              item_id: "SKU_" + item.sku,
              item_name: item.name,
              price: item.price,
              quantity: submittedQty,
            },
          ],
        };
        dispatchEvent(new CustomEvent(ADD_TO_CART_EVENT, { detail }));
      }
      break;
    case DELETE_ITEM_FROM_CART_EVENT:
      {
        /** @type {[MagentoCart, number]} */
        const [cart, item_id] = params;

        /** @type {MagentoCartItem | undefined} */
        const item = cart.items
          .filter((item) => item.item_id === item_id)
          .pop();

        if (item === undefined) {
          return;
        }

        /** @type {MagentoCartItem} */
        item;

        const detail = {
          currency: "GBP",
          value: Number((item.price * item.qty).toFixed(2)),
          items: [
            {
              id: "SKU_" + item.sku,
              item_name: item.name,
              price: item.price,
              quantity: item.qty,
            },
          ],
        };

        window.dispatchEvent(
          new CustomEvent(REMOVE_FROM_CART_EVENT, { detail })
        );
      }
      break;
    case REMOVE_FROM_CART_EVENT:
      {
        /** @type {[MagentoCart, string, number]} */
        const [cart, submittedSku, submittedQty] = params;

        /** @type {MagentoCartItem | undefined} */
        const item = cart.items
          .filter((item) => item.sku === submittedSku)
          .pop();

        if (item === undefined) {
          return;
        }

        /** @type {MagentoCartItem} */
        item;

        const detail = {
          currency: "GBP",
          value: Number((item.price * submittedQty).toFixed(2)),
          items: [
            {
              id: "SKU_" + item.sku,
              item_name: item.name,

              price: item.price,
              quantity: submittedQty,
            },
          ],
        };

        window.dispatchEvent(
          new CustomEvent(REMOVE_FROM_CART_EVENT, { detail })
        );
      }
      break;
    case PURCHASE_EVENT:
      {
        /** @type {[any]} */
        const [order] = params;
        const date = Date.now();
        console.log(order)
        const newOrder = {
          id: order.number.number,
          number: order.number.number,
          invoices: order.number.number,
          //@ts-ignore
          order_date: order.order_date ? order.order_date : date,
          status: order.number.status,
          total: order.checkout.prices.grand_total.value,
          email: order.checkout.email,
          items: order.checkout.itemsV2.items,
          coupon: order.checkout.applied_coupons,
          billing_address: {
            city: order.checkout.billing_address.city,
            country_id: order.checkout.billing_address.country.code,
            firstname: await toSHA256String(order.checkout.billing_address.firstname),
            lastname: await toSHA256String(order.checkout.billing_address.lastname),
            postcode: order.checkout.billing_address.postcode,
            region: order.checkout.billing_address.region,
            street: await toSHA256String(`${order.checkout.billing_address.street[0]}, ${order.checkout.billing_address.street[1]},`),
            telephone: await normalizeAndHashPhoneNumber(order.checkout.billing_address.telephone),
          },
          shipping_address: {
            city: order.checkout.shipping_addresses[0].city,
            country_id: order.checkout.shipping_addresses[0].country.code,
            firstname: await toSHA256String(order.checkout.shipping_addresses[0].firstname),
            lastname: await toSHA256String(order.checkout.shipping_addresses[0].lastname),
            postcode: order.checkout.shipping_addresses[0].postcode,
            region: order.checkout.shipping_addresses[0].region,
            street: await toSHA256String(`${order.checkout.shipping_addresses[0].street[0]}, ${order.checkout.shipping_addresses[0].street[1]},`),
            telephone: await normalizeAndHashPhoneNumber(order.checkout.shipping_addresses[0].telephone),
          },
        }
        window.dispatchEvent(new CustomEvent(PURCHASE_EVENT, { detail: newOrder }));
      }
      break;
    case VIEW_ITEM_EVENT:
      {
        /** @type {[PublicProduct]} */
        const [product] = params;

        const productPrice =
          Number(product.price) > Number(product.specialPrice)
            ? Number(product.price)
            : Number(product.specialPrice);
        const discount =
          Number(product.price) > Number(product.specialPrice)
            ? 0.0
            : Number(product.price) - Number(product.specialPrice);

        const detail = {
          currency: "GBP",
          value: productPrice,
          items: [
            {
              id: `SKU_${product.sku}`,
              item_name: product.name,
              discount: discount,
              price: Number(product.price),
              quantity: 1
            }
          ],
        };

        window.dispatchEvent(new CustomEvent(VIEW_ITEM_EVENT, { detail }));
      }
      break;
    case VIEW_CART_EVENT:
      {
        /** @type {[MagentoCart, MagentoCartTotals]} */
        const [cart, cartTotals] = params;
        const detail = {
          currecy: cartTotals.base_currency_code,
          value: cartTotals.grand_total,
          items: cart.items.map(item => {
            return {
              item_id: `SKU_${item.sku}`,
              item_name: item.name,
              price: item.price,
              quantity: item.qty,
            }
          }),
        };
        window.dispatchEvent(new CustomEvent(VIEW_CART_EVENT, { detail }));
      }
      break;
    case LOGIN:
      {
        /**@type {[string]} */
        const [email] = params;
        const detail = {
          method: 'Form_login',
          email: email,
        }
        window.dispatchEvent(new CustomEvent(LOGIN, { detail }));
      }
      break;
    case SIGN_UP:
      {
        const [email] = params;
        const detail = {
          method: 'Form_signup',
          email: email,
        }
        window.dispatchEvent(new CustomEvent(SIGN_UP, { detail }));
      }
      break;
    case VIEW_PROMOTION:
      {
        const [name, id, items] = params;
        const detail = {
          creative_name: name,
          creative_slot: name,
          promotion_id: id,
          promotion_name: name,
          items: items.map(/**@param {PublicProduct[]}item*/(item) => `SKU_${item[0].sku}`),
        }
        window.dispatchEvent(new CustomEvent(VIEW_PROMOTION, { detail }));
      }
      break;
    case SEARCH:
      {
        const [term] = params;
        const detail = {
          search_term: term,
        }
        window.dispatchEvent(new CustomEvent(SEARCH, { detail }))
      }
      break;
    case CHECKOUT:
      {
        const [checkout] = params;

        const detail = {
          id: checkout.id,
          currency: 'GBP',
          value: checkout.value,
          coupon: checkout.coupon || '',
          email: checkout.email,
          items: checkout.items.map(/**@param {PublicProduct}item*/item => `SKU_${item.sku}`),
        }
        window.dispatchEvent(new CustomEvent(CHECKOUT, { detail }))
      }
      break;
  }
};

/** @param {Event|CustomEvent} e */
function addToCartAction(e) {
  /** @ts-ignore */
  if (typeof gtag !== "undefined") {
    /** @ts-ignore */
    gtag("event", ADD_TO_CART_EVENT, e.detail);
  }

  // Add here the claviyo event
}

/** @param {Event|CustomEvent} e */
function removeFromCartAction(e) {
  /** @ts-ignore */
  if (typeof gtag !== "undefined") {
    /** @ts-ignore */
    gtag("event", REMOVE_FROM_CART_EVENT, e.detail);
  }

  // Add here the claviyo event
}

/** @param {Event|CustomEvent} e */
function purchaseAction(e) {

  const order = /** @type {CustomEvent} */(e).detail;
  /** @ts-ignore */
  if (typeof gtag !== "undefined") {

    const gDetail = {
      id: order.number,
      number: order.number,
      invoices: order.number,
      order_date: order.order_date,
      status: order.status,
      total: order.total,
      coupon: order.coupon,
      email: order.email,
      /**@ts-ignore*/
      items: order.items.map((item) => {
        return {
          item_id: `SKU_${item.product.sku}`,
          item_name: item.product.name,
          price: item.prices.price.value,
          quantity: item.quantity,
        };
      }),
      billing_address: {
        city: order.billing_address.city,
        country_id: order.billing_address.country_id,
        firstname: order.billing_address.firstname,
        lastname: order.billing_address.lastname,
        postcode: order.billing_address.postcode,
        region: order.billing_address.region,
        street: order.billing_address.street,
        telephone: order.billing_address.telephone,
      },
      shipping_address: {
        city: order.shipping_address.city,
        country_id: order.shipping_address.country_id,
        firstname: order.shipping_address.firstname,
        lastname: order.shipping_address.lastname,
        postcode: order.shipping_address.postcode,
        region: order.shipping_address.region,
        street: order.shipping_address.street,
        telephone: order.shipping_address.telephone,
      },
    }
    /** @ts-ignore */
    gtag("event", PURCHASE_EVENT, gDetail);
  }

  // OWA Transaction Tracker
  /** @ts-ignore */
  if (typeof OWATracker !== "undefined") {
    /** @ts-ignore */
    OWATracker.addTransaction(
      order.number,
      "",
      order.total?.grand_total?.value,
      order.total?.total_tax?.value
    );

    for (const item of order.items) {
      /** @ts-ignore */
      OWATracker.addTransactionLineItem(
        order.number, // order_id,
        item.product_sku, // sku, 
        item.product_name, //  product_name, 
        "", //  category, 
        item.product_sale_price?.value, // unit_price, 
        item.quantity_ordered // quantity 
      );
    }

    /** @ts-ignore */
    OWATracker.trackTransaction();
  }

  // Add here the claviyo event
}

/** @param {Event|CustomEvent} e */
function viewItemAction(e) {
  /** @ts-ignore */
  if (typeof gtag !== "undefined") {
    /** @ts-ignore */
    gtag("event", VIEW_ITEM_EVENT, e.detail);
  }
}

/** @param {Event|CustomEvent} e */
function viewCartAction(e) {
  /** @ts-ignore */
  if (typeof gtag !== "undefined") {
    /** @ts-ignore */
    gtag("event", VIEW_CART_EVENT, e.detail);
  }
}

/** @param {Event|CustomEvent} e */
function owaHashChangeAction(e) {
  /** @ts-ignore */
  if (typeof OWATracker !== "undefined") {
    setTimeout(() => {
      /** @ts-ignore */
      window.OWATracker.setPageTitle(document.title)
      /** @ts-ignore */
      window.OWATracker.trackPageView(window.location.hash.substring(1))
    }, 200)
  }
}

/** @param {Event|CustomEvent} e */
function login(e) {
  /** @ts-ignore */
  if (typeof gtag !== "undefined") {
    /** @ts-ignore */
    gtag("event", LOGIN, e.detail);
  }
}

/**@param {Event | CustomEvent}e */
function signup(e) {
  //@ts-ignore
  if (typeof gtag !== "undefined") {
    //@ts-ignore
    gtag('event', SIGN_UP, e.detail);
  }
}
/**@param {Event | CustomEvent}e */
function viewPromotion(e) {
  //@ts-ignore
  if (typeof gtag !== "undefined") {
    //@ts-ignore
    gtag('event', VIEW_PROMOTION, e.detail);
  }
}

/**@param {Event | CustomEvent}e */
function search(e) {
  //@ts-ignore
  if (typeof gtag !== "undefined") {
    //@ts-ignore
    gtag('event', SEARCH, e.detail);
  }
}
/**@param {Event | CustomEvent}e */
function checkout(e) {
  //@ts-ignore
  if (typeof gtag !== "undefined") {
    //@ts-ignore
    gtag('event', CHECKOUT, e.detail);
  }
}


export function addEventListeners() {
  window.addEventListener(ADD_TO_CART_EVENT, addToCartAction, false);
  window.addEventListener(REMOVE_FROM_CART_EVENT, removeFromCartAction, false);
  window.addEventListener(PURCHASE_EVENT, purchaseAction, false);
  window.addEventListener(VIEW_ITEM_EVENT, viewItemAction, false);
  window.addEventListener(VIEW_CART_EVENT, viewCartAction, false);
  window.addEventListener('hashchange', owaHashChangeAction, false);
  window.addEventListener(LOGIN, login, false);
  window.addEventListener(SIGN_UP, signup, false);
  window.addEventListener(VIEW_PROMOTION, viewPromotion, false);
  window.addEventListener(SEARCH, search, false);
  window.addEventListener(CHECKOUT, checkout, false);
}
